export default __webpack_public_path__ + "static/media/KME.9ad30274.svg";